import { isEmpty } from 'lodash/fp';

import { ConsiderationContent, Service } from '../../../../../types/__codegen__/sanity/graphql';
import { ConsiderationPageSlug } from '../../../types';
import { CONTENT_SECTIONS } from '../../../content/sections';
import HealthWidget from '../../../../home/components/health-widget';

type HeaderContentProps = {
  cmsData?: ConsiderationContent & {
    summary?: Service['summaryRaw'];
  };
  removePaddingTop?: boolean;
  slug: ConsiderationPageSlug;
};

const pagesWithEmbeddedQuote: ConsiderationPageSlug[] = ['health-insurance-ccs'];

const mapHeaderContent = ({ cmsData, removePaddingTop, slug }: HeaderContentProps) => {
  if (isEmpty(cmsData)) {
    return null;
  }

  const { urlObject, imageObject, summary, title } = cmsData;

  const footerSection = pagesWithEmbeddedQuote.includes(slug)
    ? {
        footer: <HealthWidget variant="inline" />,
      }
    : {
        cta: {
          title: urlObject?.name,
          to: urlObject?.url,
        },
      };

  const mappedCmsContent = {
    image: {
      alt: imageObject?.caption,
      src: imageObject?.image?.asset?.url,
    },
    orderIndex: 1,
    removePaddingTop,
    subtitle: summary,
    title,
    type: CONTENT_SECTIONS.HEADER,
    ...footerSection,
  };

  return mappedCmsContent;
};

export default mapHeaderContent;
